import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';

@Component({
    selector: 'message-dialog',
    imports: [CommonModule],
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss']
})
export class MessageDialogComponent implements OnInit {
    @Input()
    title: string = 'Notice!';

    @Input()
    message: string = 'Add your message here';

    @Input()
    type: string = 'Info';

    iconContainerClass: string = 'info-icon-container';
    iconClass: string = 'fa-info info-dialog-icon'
    buttonClass: string = '';
    confirmSubject: Subject<boolean>;

    constructor() {
        this.confirmSubject = new Subject<boolean>();
    }

    ngOnInit() {
        if (this.type.toLowerCase() === 'success') {
            this.iconContainerClass = 'success-icon-container';
            this.iconClass = 'fa-check success-dialog-icon';
            this.buttonClass = 'button-success';
        }
        else if (this.type.toLowerCase() === 'error') {
            this.iconContainerClass = 'error-icon-container';
            this.iconClass = 'fa-xmark error-dialog-icon';
            this.buttonClass = 'button-delete';
        }
        else if (this.type.toLowerCase() === 'warning') {
            this.iconContainerClass = 'warning-icon-container';
            this.iconClass = 'fa-exclamation warning-dialog-icon';
        }
    }

    show(title: string, message: string, type: string): Subject<boolean> {
        this.title = title;
        this.message = message;
        this.type = type;

        return this.confirmSubject;
    }

    onConfirm(): void {
        this.confirmSubject.next(true);
        this.confirmSubject.complete();
    }

    onCancel(): void {
        this.confirmSubject.next(false);
        this.confirmSubject.complete();
    }
}